import { ActivityMonitorContainerProps } from "./types";
import { Card } from "react-bootstrap";
import CircularTabs from "app/storybookComponents/Tabs/CircularTabs";
import ActivityMonitorBox from "./ActivityMonitorBox";
import React from "react";
import { Skeleton } from "app/shadcnComponents/ui/skeleton";

const ActivityMonitorContainer = ({
  title,
  labelTags,
  activeTag,
  onTagClick,
  footer = null,
  boxPropsOrOverrides,
  timeInterval = "week",
  titleTag = null,
  emptyStateContent = null,
  isEmpty = false,
  headerCornerContent = null,
  className = null,
  banners = null,
  isLoading = false,
  loadingSkeletonCount = 4,
}: Readonly<ActivityMonitorContainerProps>) => {
  const getBoxes = () => {
    if (isLoading) {
      return (
        <div className="flex flex-row gap-3">
          {Array.from({ length: loadingSkeletonCount }).map((_, index) => (
            <Skeleton key={index} className="h-48 w-full" />
          ))}
        </div>
      );
    }
    if (!boxPropsOrOverrides) return null;
    if (React.isValidElement(boxPropsOrOverrides)) {
      return boxPropsOrOverrides;
    }
    return (
      <div className="activity-monitor-boxes">
        {boxPropsOrOverrides?.map((boxProp) => {
          if ("title" in boxProp) {
            return (
              <ActivityMonitorBox
                key={boxProp.title}
                timeInterval={timeInterval}
                {...boxProp}
              />
            );
          }
          return boxProp;
        })}
      </div>
    );
  };

  const getContent = () => {
    if (isEmpty) {
      return emptyStateContent;
    }

    return (
      <>
        <CircularTabs
          tabs={labelTags.map((tag) => ({ label: tag }))}
          selectedTab={activeTag ?? undefined}
          onTabSelected={onTagClick}
        />
        {getBoxes()}
        {footer}
      </>
    );
  };

  const getClassName = () => {
    let baseClassName = "activity-monitor-container";

    if (className) {
      baseClassName += ` ${className}`;
    }
    return baseClassName;
  };

  return (
    <Card className={getClassName()}>
      <div className="activity-monitor-container__header">
        <div className="activity-monitor-container__title">
          <h2>{title}</h2>
          {titleTag}
        </div>
        {headerCornerContent}
      </div>
      {banners}
      {getContent()}
    </Card>
  );
};

export default ActivityMonitorContainer;
